import { getProrate } from 'Api/AccountApi';
import { updatePaymentAccount as updateAccount } from 'Api/ProfileApi';
import {
  RESET_TAX,
  UPDATE_TAX,
  UPDATE_SHIPPING_ADDRESS,
  RESET_SHIPPING_ADDRESS,
  UPDATE_PAYMEMT_ACCOUNT_SUCCESS,
  SET_PAYPAL_ERROR,
  TAX_UNAVAILABLE,
  SUCCESSFUL_PAYMENT,
  CLEAR_CHECKOUT,
} from '../Types';

// action creators
export const updateTax = (payload) => ({ type: UPDATE_TAX, payload });
export const taxUnavailable = () => ({ type: TAX_UNAVAILABLE });
export const resetTax = () => ({ type: RESET_TAX });
export const updateShippingAddress = (payload) => ({ type: UPDATE_SHIPPING_ADDRESS, payload });
export const resetShippingAddress = () => ({ type: RESET_SHIPPING_ADDRESS });
export const updatePaymentAccountSuccess = () => ({ type: UPDATE_PAYMEMT_ACCOUNT_SUCCESS });
export const setPaypalError = (payload) => ({ type: SET_PAYPAL_ERROR, payload });
export const successfulPayment = () => ({ type: SUCCESSFUL_PAYMENT });
export const clearCheckout = () => ({ type: CLEAR_CHECKOUT });

// action thunk
export const updateTaxByZip =
  ({ GetProrateWithTaxResponseMessage: { responseCode = '0', totalTax = 0, isTaxError = false, billingAddress } }) =>
  (dispatch) =>
    dispatch(updateTax({ totalTax, isTaxError: isTaxError || responseCode === '0', billingAddress }));

export const getTaxByZip = (zipCode) => {
  return async (dispatch, getState) => {
    const {
      plans: { selectedPlan },
    } = getState();

    const { planId } = selectedPlan;

    return getProrate({
      serviceID: planId,
      zipCode,
    })
      .then((res) => res.data)
      .then((data) => {
        // TODO: middleware proxy does not return "isTaxError" property, add on BE response
        const { totalTax = 0, isTaxError = false, billingAddress } = data;
        dispatch(updateTax({ totalTax, isTaxError, billingAddress }));
      });
  };
};

//This creates an Evergent account for Fox users that don't have one
//E.g. for a user that made a free Fox account on Fox Sports
export const updatePaymentAccount = () => {
  return async (dispatch, getState) => {
    const { user } = getState();
    return updateAccount(user).then(() => dispatch(updatePaymentAccountSuccess()));
  };
};
